import axios from "axios";
import swal from "sweetalert2";
import { GoogleLogin } from '@react-oauth/google';

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

function Login() {
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [state, setState] = useState(globalState.state);

    async function login() {
        setSubmitting(true);

        try {
            const form = document.getElementById("form-login");
            const formData = new FormData(form);

            const response = await axios.post(
                baseUrl + "/api/login",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const accessToken = response.data.access_token;
                localStorage.setItem(accessTokenKey, accessToken);
                fetchMe();

                /*localStorage.setItem("email", form.email.value);

                swal.fire("Login", response.data.message, "info")
                    .then(function () {
                        navigate("/verify");
                    });*/
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    async function fetchMe() {
        try {
            const response = await axios.post(
                baseUrl + "/api/me",
                null,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const user = response.data.user;
                setState({
                    user: user
                });
                globalState.setState({
                    user: user
                });
                navigate("/");
            } else {
                // swal.fire("Error", response.data.message, "error")
            }
        } catch (exp) {
            console.log(exp.message);
        }
    }

    async function loginWithGmail(credentialResponse) {
        setSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("token", credentialResponse.credential);

            const response = await axios.post(
                baseUrl + "/api/login-with-google",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const accessToken = response.data.access_token;
                /*const user = response.data.user;
                globalState.setState({
                    user: user
                });*/

                localStorage.setItem(accessTokenKey, accessToken);
                fetchMe();
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }
    }

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Login</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Login</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Login</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-5 text-center">Login and be able to see CVs you have received, or companies you have been shortlisted.</p>

                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    login();
                                } } id="form-login">
                                    <div className="row g-3">
                                        <div className="offset-md-3 col-md-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-floating">
                                                        <input type="email" className="form-control" name="email" placeholder="Email" required />
                                                        <label>Email</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-3">
                                                    <div className="form-floating">
                                                        <input type="password" className="form-control" name="password" placeholder="Password" required />
                                                        <label>Password</label>
                                                    </div>
                                                </div>

                                                {/*<div className="col-md-12 text-center mt-5 mb-5">
                                                    <label>
                                                        Recruiter&nbsp;
                                                        <input type="radio" name="type" value="recruiter" />
                                                    </label>

                                                    <label className="ms-5">
                                                        Job seeker&nbsp;
                                                        <input type="radio" name="type" value="job_seeker" />
                                                    </label>
                                                </div>*/}

                                                <div className="col-md-12 mt-3 mb-3">
                                                    {/*<GoogleLogin
                                                        onSuccess={credentialResponse => {
                                                          loginWithGmail(credentialResponse); // contains JWT token
                                                          // You can decode token and send it to your backend
                                                        }}
                                                        onError={() => {
                                                          swal.fire('Login Failed', "", "error");
                                                        }}
                                                    />*/}
                                                </div>

                                                <button className="btn btn-primary" type="submit"
                                                    disabled={ submitting }>Login</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Login;